import { Component } from '@angular/core';
import { ButtonModule } from 'primeng/button';
import { CalendlyService } from '../../services/calendly/calendly.service';

@Component({
  selector: 'app-integrate-calenderly',
  standalone: true,
  imports: [ButtonModule],
  templateUrl: './integrate-calenderly.component.html',
  styleUrl: './integrate-calenderly.component.scss'
})
export class IntegrateCalenderlyComponent {

  constructor(private calendlyService:CalendlyService) { }

  integrateCalendly() {
    this.calendlyService.getAuthUrl().subscribe((res: any) => {
      window.location.href = res.authUrl;
    });
  }
}
